<template>
  <router-view />
</template>

<style>
  @import 'assets/css/custom.css';
  @import 'assets/css/style.bundle.css';
  @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css');
 </style>